import { render, staticRenderFns } from "./TeamsDashboard.vue?vue&type=template&id=26a63098&"
import script from "./TeamsDashboard.vue?vue&type=script&lang=js&"
export * from "./TeamsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports